module.exports = __webpack_public_path__ + "img/logo-orig.21f85ae5.svg";